import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=52f17f2f&lang=pug&"
import script from "./proxy.vue?vue&type=script&lang=js&"
export * from "./proxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports